<template>
  <button
    class="primary-button button"
    @click="onclick"
    @mouseover="onmouseover"
    :class="{
      disabled,
      blue,
      green,
      grey,
      white,
      atlantis,
      independence,
      pizazz,
      'rounded-corner': roundedCorner,
      'pure-icon': pureIcon
    }"
    :type="type"
    :title="pureIcon ? text : ''"
  >
    <slot v-if="hasIcon" name="icon" />
    <span v-if="!pureIcon">{{ text }}</span>
  </button>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
  name: 'PrimaryButton',
  props: {
    text: String,
    type: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    blue: Boolean,
    green: Boolean,
    grey: Boolean,
    white: Boolean,
    atlantis: Boolean,
    independence: Boolean,
    pizazz: Boolean,
    roundedCorner: Boolean,
    icon: Object,
    iconPosition: String,
    pureIcon: Boolean
  },
  setup(props, { emit, slots }) {
    const onclick = (e) => {
      emit('click', e);
    };

    const onmouseover = (e) => {
      emit('mouseover', e);
    };

    const hasIcon = computed(() => !!slots.icon);

    return {
      onclick,
      onmouseover,
      hasIcon
    };
  }
};
</script>

<style lang="scss">
@import '~@/assets/scss/colors';

.primary-button {
  height: 40px;
  border: 0;
  border-radius: 0;
  display: inline-block;
  box-sizing: border-box;
  padding: 0 40px;
  color: $babyPowder;
  background-color: $geranium;
  font-size: 16px;
  font-weight: bold;
  transition: all .2s ease-in-out;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1;
  user-select: none;
  white-space: nowrap;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    box-sizing: border-box;
    background-color: $babyPowder;
    transition: all .2s ease-in-out;
    transform: translateY(-100%) rotate(-45deg);
    transform-origin: left bottom;
  }

  &.disabled {
    border-color: $grey;
    background-color: $grey;
    pointer-events: none;
  }

  &.white {
    background-color: $white;
    color: $geranium;
  }

  &.grey {
    background-color: $grey;
    color: $white;
  }

  &.atlantis {
    background-color: $atlantis;
    color: $white;
  }

  &.blue {
    background-color: $blueNcs;
    color: $white;
  }

  &.green {
    background-color: $shamrockGreen;
    color: $white;
  }

  &.independence {
    background-color: $independence;
    color: $white;
  }

  &.pizazz {
    background-color: $pizazz;
    color: $white;
  }

  &.rounded-corner {
    border-radius: 20px;
  }

  &:hover {
    color: $independence;

    &::before {
      transform: translateY(0) rotate(0);
    }
  }

  svg {
    position: relative;
    top: calc(50% - 18px);
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }

  &.pure-icon {
    width: 40px;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: center;

    svg {
      position: static;
      margin: 0;
    }
  }

  &:active, &:focus {
    outline: none;
  }
}
</style>
